import { render, staticRenderFns } from "./UnsubscribeModal.vue?vue&type=template&id=4b2d8472&scoped=true&"
import script from "./UnsubscribeModal.vue?vue&type=script&lang=js&"
export * from "./UnsubscribeModal.vue?vue&type=script&lang=js&"
import style0 from "./UnsubscribeModal.vue?vue&type=style&index=0&id=4b2d8472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2d8472",
  null
  
)

export default component.exports